export default {
  "line": "_line_2ip57y",
  "backgroundAnimation": "_backgroundAnimation_2ip57y",
  "standalone": "_standalone_2ip57y"
};